
module.exports = ToggleExpanded =
  toggleExpanded: (e) ->
    @setState expanded: !@state.expanded



// WEBPACK FOOTER //
// ./app/js/mixins/toggle_expanded.coffee